<template>
  <div>
    <page-header v-bind:subtitle="$t('subtitle')"
                 v-bind:title="$t('title')" />

    <v-container v-bind:class="{ 'pa-0': !this.$vuetify.breakpoint.mdAndUp }">
      <food-truck-dialog ref="foodTruckDialog"
                        v-bind:food-truck="selectedFoodTruck"
                        v-model="foodTruckDialog" />

      <food-truck-list-card v-bind:loading="loading"
                            v-bind:food-trucks="onlyFoodTrucks"
                            v-on:food-truck-selected="showFoodTruckDialog($event)" />
    </v-container>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  import FoodTruckDialog from '@/components/FoodTruckDialog'
  import FoodTruckListCard from '@/components/FoodTruckListCard'
  import PageHeader from '@/components/common/PageHeader'

  export default {
    components: {
      FoodTruckDialog,
      FoodTruckListCard,
      PageHeader
    },
    computed: {
      onlyFoodTrucks() {
        return this.foodTrucks.filter(f => !f.partner)
      },
      selectedFoodTruck() {
        if (this.foodTruckId == null) {
          return {}
        }

        return this.foodTruck(this.foodTruckId)
      },
      ...mapGetters([
        'foodTruck',
        'foodTrucks'
      ])
    },
    async created() {
      // Only show placeholders when there is nothing to show yet
      this.loading = this.foodTrucks.length === 0

      try {
        await this.loadCategories()
        await this.loadFoodTrucks()
      } finally {
        this.loading = false
      }
    },
    data: () => ({
      loading: false,
      foodTruckDialog: false,
      foodTruckId: null
    }),
    methods: {
      showFoodTruckDialog(id) {
        this.foodTruckId = id

        this.$refs.foodTruckDialog.open()
      },
      ...mapActions([
        'loadCategories',
        'loadFoodTrucks'
      ])
    },
    name: 'List'
  }
</script>

<i18n>
  {
    "de": {
      "subtitle": "Alle Food Trucks nach Region – heute geöffnete stehen oben.",
      "title": "Unsere Trucks"
    },
    "en": {
      "subtitle": "All food trucks by region – the ones open today come first.",
      "title": "Our trucks"
    }
  }
</i18n>
